import React from 'react';
import { isEmpty } from 'lodash';
import { Identifier, LoanInprogressWrapperProps } from '@types';
import { useSelector } from 'react-redux';
import { selectLipTile } from '@store/selectors/lip.selector';
import { TileCard } from 'fmc-digital-originations';
import { logUserEvent } from 'fmc-digital-common';
import { selectLoan } from '@store/selectors/widgets.selectors';

const LoanInprogressWrapper: React.FC<LoanInprogressWrapperProps> = ({ getOption }) => {
    const lipTile = useSelector(selectLipTile);
    const loanList: Identifier[] = useSelector(selectLoan);

    const handleNavigation = (loanNumber: string): void => {
        logUserEvent({
            action: 'LoanInProgressClicked',
            type: 'DashboardLIPTile',
            description: `Dashboard LIP Tile`
        });

        const loan = loanList.find(ele => +ele.identifier === +loanNumber);

        if (loan) getOption(loan);
    };

    return (
        <>
            {!isEmpty(lipTile) &&
                lipTile.map((tileCard: any, index: number) => (
                    <TileCard key={index} template={tileCard} onClickHandle={handleNavigation} />
                ))}
        </>
    );
};

export default React.memo(LoanInprogressWrapper);
